import { WebChatSettings } from '@ucc/cc-common-ui';
import { Environments, getEnvString } from 'environments';
import { AnyAction, Dispatch } from 'redux';
import { dispatchMessageEvent } from 'state/Events/actions';
import { EventsType } from 'state/Events/types';
import { AppState } from 'state/reducer';
import { isTrusted } from 'utils/domains';
import { fetchWithState } from 'utils/fetch';

import { setConfig } from '.';
import { MOCK_CONFIGURATION } from './mocks';

export const fetchAppConfig =
  () => async (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
    const response = await fetchWithState(dispatch, getState)('configuration');
    if (response) {
      const config = (await response.json()) as WebChatSettings;
      if (isTrusted(getState().widgetConfiguration?.hostReferer, config.domainNames)) {
        dispatch(setConfig(config));
        dispatchMessageEvent({
          type: EventsType.CC_WEBCHAT_INITIALIZED,
          payload: {
            position: config.theme?.pagePosition,
          },
        });
      }
    } else if (getEnvString() === Environments.LOCAL) {
      dispatch(setConfig(MOCK_CONFIGURATION));
      dispatchMessageEvent({
        type: EventsType.CC_WEBCHAT_INITIALIZED,
        payload: {
          position: MOCK_CONFIGURATION.theme?.pagePosition,
        },
      });
    }
  };
